export const SUPPLIER_TERMS_URL =
  'https://arcessio-my.sharepoint.com/:b:/g/personal/kunal_arcessio_ai/IQBfvH9L_oz4SqvOaJ3WD2DYAcWzKWCBnA2BB6Qyx_ZiCRc?e=JG7h6B';

export interface SupplierTermsAcceptance {
  url: string;
  acceptedAt: string;
  acceptedBy: { userId: string; name: string; email: string | null };
}

export interface SupplierTermsStatus {
  currentUrl: string;
  acceptance: SupplierTermsAcceptance | null;
}
